<template>
	<!-- 派单管理 -->
	<div class="billOperationRecord public_Spacing">
		<div class="pulbic_oparetionBlock" style="margin-bottom: 12px;">
			<div class="public_criteriaRange">

				<div class="public_oparetionBlock_Menu" v-if="this.uobj.pertb005.pertb005cb00 =='CUS-1'">
					<label class="public_lbSty">加油站：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="ORMTB474CA00" placeholder="请选择"
						filterable>
						<el-option v-for="item in oilList" :key="item.ORMTB473ID" :label="item.ORMTB473CA00"
							:value="item.ORMTB473ID">
						</el-option>
					</el-select>
				</div>
				<div class="public_operatBtn">
					<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor" id="查询"><i
							class="iconfont icon-chaxun"></i>查询</button>
				</div>
			</div>
		</div>
		<div id="统计" style="width: 100%;">
			<div class="pulbic_oparetionBlock public_statisticsInfo">
				<div class="public_statistics billDetails-statistics">
					<div class="public_statisticsContent">
						<img class="imgStatistics" src="../../assets/images/orderStatistics/money.png">
						<div class="payType">金额</div>
					</div>
					<ul class="billDetails-ul">
						<li class="pulic_statistics_titlt"><span class="totolTitle">充值金额(元)</span><span
								class="singular">{{expprice}}</span></li>
					</ul>
				</div>
			</div>
		</div>
		<div class="billOperationRecord-table pulbic_table_container">
			<el-table tooltip-effect="dark" :data="tableData" style="width: 100%;"
				:default-sort="{prop: 'waterNum', order: 'descending'}"
				:header-cell-style="{color:'rgba(51,51,51,1)', background:'rgba(184,227,255,1)','font-weight':'bold'}"
				class="public_tableColumn">
				<el-table-column v-for='(item,index) in tableHeadList' :width="item.width" :prop="item.prop"
					:label="item.label" :key="index">
				</el-table-column>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total,sizes, prev, pager, next" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<script>
	import qs from 'qs'
	import {
		createLogger
	} from 'vuex';
	import debounce from '../../api/debounce';
	export default {
		data() {
			return {
				formdata: new FormData(),

				loadingBut: false,
				confirmTxt: 0,
				isorderAuditText: '',
				oerderDetilsShow: false,
				orderAuditShow: false,
				isorderAuditShow: false,
				returnReceiptShow: false,
				uobj: this.$store.state.uobj, //登陆缓存--用户信息
				date: [], //日期
				startTime: '',
				endTime: '',
				dateNowDayActive: false,
				dateYesterdayActive: false,
				dateNowMonthActive: false,
				dateLastMonthActive: false,
				twolevelUserLogin: true,
				timeIndex: 0, //判断第几次切换当月时间
				sameMonthTime: '', //目前月份
				currentMonthTime: '', //目前月份--上月+1
				tableData: [],
				ORMTB440CA00: '',
				materialOptions: [],
				materialTypeValue: '',
				oilList: [{
					ORMTB473ID: '',
					ORMTB473CA00: '全部',
				}],
				carNum: '',
				materielMo: '',
				materielOptions: [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}],
				// 收支
				orOptions: [{
					value: '',
					label: '全部',
				}, {
					value: '1',
					label: '收入',
				}, {
					value: '2',
					label: '支出',
				}],

				incount: 0,
				expcount: 0,
				inprice: 0,
				expprice: 0,
				expcap: 0,
				// 查询
				ORMTB474CA00: '', //加油站


				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				// 详情
				detailsList: '', //详情列表
				tableHeadList: [
					{
						prop: 'ORMTB702CA02',
						label: '油站名称',

					},
					{
						prop: 'ORMTB702CA00',
						label: '充值金额',

					},
					{
						prop: 'ORMTB702CA03',
						label: '操作人',

					},
					{
						prop: 'ORMTB702CA04',
						label: '操作时间',

					}
				],

				isRefresh: true,
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: '',
				// 时间限制
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				solelist: [],
				DetailsWaterurl: '',
				DetailsWatersrcList: [],
				DetailsWeightrcList: [],
				DetailsWeightrcBDList: [],
				ewmDetails: [],
				materialList: [],
				materialValue: '',
				listTick: null, // 列表刷新定时器
				timeType: '1',
				distf: true,
				dcmoreID: '',
				dcmore: '',
			}
		},
		watch: {
			weightOpt: {
				handler(val) {
					if ((val.tare || val.tare === 0) && (val.gross || val.gross === 0) && (val.price || val.price === 0)) {
						let tare = parseFloat(val.tare)
						let gross = parseFloat(val.gross)
						this.detailsList.ORMTB440CC04 = (tare - gross).toFixed(2)
						if (this.detailsList.ORMTB440CC04) {
							debounce(this.getSettlementAmount, 500)
						}
					} else {
						this.detailsList.ORMTB440CC04 = ''
						this.detailsList.ORMTB440CC06 = ''
					}
				},
				deep: true
			},
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			// console.log(list)
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			}
			// console.log(this.historyInfo)
			// else {
			// 	this.getNowDay();
			// }
			var path = this.$route.path;
			if (path === '/oilCardBill') {
				path = '/Home' + path
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表

			// console.log(this.solelist)
		},
		mounted() {
			if (this.historyInfo == null && this.$route.query.mark == null) {
				this.getNowDay();
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = true
			}

			this.fetchOilList()
			// this.listTick = setInterval(() => {
			// 	this.queryClick()
			// }, 1000 * 60)
			// console.log(this.$store.state.uobj)

			this.pageList()
		},
		// 存储数据
		beforeDestroy() {
			clearInterval(this.listTick)
			this.listTick = null
			this.startTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[0]));
			this.endTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[1]));
			var obj = {
				startTime: this.startTime,
				endTime: this.endTime, //开始时间
				ORMTB440CA02: this.ORMTB440CA02, //客户id
				ORMTB400CA03: this.ORMTB400CA03, //客户名称
				ORMTB440CA04: this.ORMTB440CA04, //客户名称
				ORMTB440CA06: this.ORMTB440CA06, //二级企业id
				ORMTB440CA00: this.ORMTB440CA00, //数据状态--转换
				ORMTB440CA01: this.ORMTB440CA01, //数据状态--名字
				currentPage: this.currentPage, //当前页数
				pageMo: this.pageMo, //页码
				limitMo: this.limitMo, //每页条数
				dateNowDayActive: this.dateNowDayActive,
				dateYesterdayActive: this.dateYesterdayActive,
				dateNowMonthActive: this.dateNowMonthActive,
				dateLastMonthActive: this.dateLastMonthActive,
				ORMTB440CA00: this.ORMTB440CA00
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		computed: {

		},
		methods: {

			//初始化数据
			init() {
				console.log(this.historyInfo)
				this.startTime = this.historyInfo.startTime
				this.endTime = this.historyInfo.endTime
				this.date = [this.startTime, this.endTime]
				this.ORMTB440CA02 = this.historyInfo.ORMTB440CA02
				this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
				this.ORMTB440CA04 = this.historyInfo.ORMTB440CA04
				this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
				// this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
				this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
				this.currentPage = this.historyInfo.currentPage
				this.pageMo = this.historyInfo.pageMo
				this.limitMo = this.historyInfo.limitMo
				this.dateNowDayActive = this.historyInfo.dateNowDayActive
				this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
				this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
				this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
			},

			// ch
			fetchOilList() {
				var postData = {}
				var url = "/orm/ormtb473/selectAllList";
				var List = [{
					ORMTB473ID: '',
					ORMTB473CA00: '全部',
				}];
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.oilList = [...List, ...res.data.data];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			// 查询
			queryClick() {
				this.pageMo=1;
				this.pageList()
			},
			// 列表
			pageList() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB702CA01: this.ORMTB474CA00,
					page: this.pageMo,
					limit: this.limitMo,
					timeType: this.timeType
				}
				this.tableData = [];
				var url = "/orm/ormtb702/selectPageList";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					console.log(res)
					if (res.data.code == 200) {
						var data = res.data.data.list;
						this.pagingPageMo = res.data.data.total;
						for (var i = 0; i < data.length; i++) {
							var customerName = "";
						}
						this.tableData = data;
						this.expprice = res.data.data.czje;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			dateFtt(fmt, date) { //author: meizz
				var o = {
					"M+": date.getMonth() + 1, //月份
					"d+": date.getDate(), //日
					"h+": date.getHours(), //小时
					"m+": date.getMinutes(), //分
					"s+": date.getSeconds(), //秒
					"q+": Math.floor((date.getMonth() + 3) / 3), //季度
					"S": date.getMilliseconds() //毫秒
				};
				if (/(y+)/.test(fmt))
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
				for (var k in o)
					if (new RegExp("(" + k + ")").test(fmt))
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
							.length)));
				return fmt;
			},

			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var Ming = new Date().getTime() + 24 * 60 * 60 * 1000;
				var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
				data = `${data} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [enddata, data];
				this.dateNowDayActive = true
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			datePickerChange(e) {
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 24 * 60 * 60 * 1000;
				var Ming = new Date().getTime();
				var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				nowDay = `${nowDay} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [nowDay, enddata];
				this.dateNowDayActive = false
				this.dateYesterdayActive = true
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取当月时间
			sameMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms));
				firstDay = `${firstDay} ${this.exchangeTiem||'00:00:00'}`
				var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000;
				var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate));
				nextDay = `${nextDay} ${this.exchangeTiem||'00:00:00'}`
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = true
				this.dateLastMonthActive = false
			},
			//获取上月时间
			lastMonth() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				var lastyear = year
				var lastmonth = month
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month == 12) {
					lastmonth = 1
				} else {
					lastmonth = lastmonth + (1 * 1)
				}
				if (month < 10) {
					month = "0" + month;
				}
				if (lastmonth < 10) {
					lastmonth = "0" + lastmonth;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem||'00:00:00'}`;
				// var lastDay = new Date(lastyear, lastmonth, 0);
				let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this.exchangeTiem||'00:00:00'}`;
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = true
			},
			handleSizeChange(val) {
				this.pageMo = 1
				this.limitMo = val;
				this.pageList();
			},
			// 点击页码
			handleCurrentChange(val) {
				this.pageMo = val;
				this.pageList();
			},
		}
	}
</script>

<style scoped>
	.CustomerfillingDig-tab {
		padding-left: 20px;
	}

	.CustomerfillingDig-tab-li,
	.rechargeType-tab-li {
		display: flex;
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: 16px;
		color: #333;
		vertical-align: top;
	}

	.CustomerfillingDig-tab-li>div {
		border: 1px solid #CDCDCD;
		border-top: none;
	}

	.CustomerfillingDig-tab-li>div:first-child {
		border-right: none;
	}

	.CustomerfillingDig-tab-li:first-child>div {
		border-top: 1px solid #CDCDCD;
	}

	.CustomerfillingDig-tab-li>div:last-child,
	.rechargeType-tab-li>div:last-child {
		border: none;
		color: #FF4D35;
	}

	.CustomerfillingDig-tab-li-text {
		flex: .8;
		background: rgba(240, 252, 255, 1);
	}

	.CustomerfillingDig-tab-li-ipt {
		flex: .8;
	}

	.rechargeType-tab-li-text {
		flex: .35;
	}

	.rechargeType-tab-li-ipt {
		flex: .7;
	}

	.CustomerfillingDig-tab-li-ipt input,
	.rechargeType-tab-li-ipt input {
		height: 46px;
		width: 100%;

		text-align: center;

		box-sizing: border-box;
		font-size: 16px;
		color: #333;
	}

	.CustomerfillingDig-tab-li-ipt input {
		outline: none;
		border: none;
		vertical-align: top;
	}

	.rechargeType-tab-li-ipt input {
		/* border-radius: 8px; */
		/* outline: none; */
	}

	.CustomerfillingDig-tab-li-b,
	.rechargeType-tab-li-b {
		flex: .3;
	}

	.CustomerfillingDig-tab-btn {
		text-align: center;
		margin-top: 30px;
	}

	.DWD-li {
		display: flex;
		height: 35px;
		line-height: 35px;
		box-sizing: border-box;
		border: 1px solid #999;
		font-size: 16px;
		color: #333;
	}

	.DWD-li>div {
		padding: 0 5px;
		height: 34px;
		overflow: hidden;
		box-sizing: border-box;
	}

	.DWD-li-title {
		width: 120px;
		text-align: center;
		border-right: 1px solid #999;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-li-text {
		flex: 1;
	}

	.DWD-li-text input {
		width: 100%;
		height: 35px;
		line-height: 35px;
		border: none;
		outline: none;
	}

	.DWD-li+.DWD-li {
		border-top: none;
	}

	.DWD-table {
		display: flex;
	}

	.DWD-table-left-flex {
		flex: 1;
	}

	.DWD-table>div>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: center;
		border-right: 1px solid #999;
		border-bottom: 1px solid #999;
		box-sizing: border-box;
	}

	.DWD-table>div>div:first-child {
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table-left-title>div {
		width: 101px;
		text-align: center;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table .DWD-table-left-title>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		box-sizing: border-box;
		border-left: 1px solid #999;
		border-bottom: 1px solid #999;
	}

	.DetailsWater-img {
		margin-top: 30px;
	}

	.DetailsWater-img-text {
		display: inline-block;
		width: 101px;
		text-align: center;
		vertical-align: top;
	}

	.car-number-add {
		/* text-transform: uppercase; */
	}

	.billOperationRecord-table {
		padding: 30px 20px 0;
	}

	.public_singleMenu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.pulic_operatArea_now:hover,
	.public_operatArea_yesterday:hover {
		background-color: #ccc;
	}

	/* 新增--列表宽度 */
	.billOperationRecord .systemCodePC-add-code-table-li-ipt {
		flex: 1.5;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_oparetionBlock_Menu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.billOperationRecord .public_oparetionBlock_Menu {
		height: 45px;
		align-items: center;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center !important;
	}

	/* 统计 START*/
	.imgStatistics {
		width: 40px;
		height: 40px;
	}

	.payType {
		font-size: 20px;
		/* font-size: 24px; */
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(102, 102, 102, 1);
		line-height: 26px;
	}

	.singular {
		font-size: 32px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
		line-height: 30px;
		vertical-align: middle;
		padding-left: 10px;
	}

	.Amount {
		font-size: 32px;
		font-family: Microsoft YaHei;
		/* font-weight:bold; */
		line-height: 30px;
		vertical-align: middle;
		padding-left: 10px;
	}

	.pulic_statistics_titlt {
		line-height: 40px;
	}

	.Customer-upload-bd {
		padding: 20px 0;
	}

	.disabled {
		.el-upload--picture-card {
			display: none;
		}
	}

	.public_lbSty {
		width: 100px;
	}

	/* 统计 END*/
</style>